import React, { useState } from "react";
import {
  Box,
  Stack,
  Typography,
  Avatar,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { tokens } from "../../../theme";
import { Sun } from "lucide-react";

const DonationNavabar: React.FC = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { label: "How it Works", href: "#how-it-works" },
    { label: "Impact", href: "#impact" },
    { label: "Community", href: "#community" },
  ];

  const handleNavClick = (href: string) => {
    const element = document.querySelector(href);
    if (element) element.scrollIntoView({ behavior: "smooth" });
    setMobileMenuOpen(false);
  };

  const scrollToDonate = () => {
    const element = document.querySelector("#donate");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      {/* PREMIUM NAVBAR */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1200,
          bgcolor: "rgba(255,255,255,0.85)",
          backdropFilter: "blur(12px)",
          borderBottom: "1px solid rgba(0,0,0,0.05)",
        }}
      >
        <Box
          sx={{
            maxWidth: 1200,
            mx: "auto",
            px: 4,
            py: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* LOGO */}
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Avatar
              sx={{
                bgcolor: colors.primary[400],
                width: 40,
                height: 40,
              }}
            >
              <Sun size={18} />
            </Avatar>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 800,
                letterSpacing: "-0.5px",
              }}
            >
              SolarFaith
            </Typography>
          </Stack>

          {/* DESKTOP LINKS */}
          <Stack
            direction="row"
            spacing={5}
            sx={{ display: { xs: "none", md: "flex" } }}
          >
            {navItems.map((item) => (
              <Typography
                key={item.label}
                onClick={() => handleNavClick(item.href)}
                sx={{
                  cursor: "pointer",
                  fontWeight: 500,
                  color: "text.primary",
                  transition: "color 0.2s ease",
                  "&:hover": {
                    color: colors.primary[400],
                  },
                }}
              >
                {item.label}
              </Typography>
            ))}
          </Stack>

          {/* CTA + MOBILE MENU */}
          <Stack direction="row" spacing={2} alignItems="center">
            <Button
              onClick={scrollToDonate}
              sx={{
                bgcolor: colors.primary[400],
                color: "#fff",
                px: 3,
                py: 1.2,
                borderRadius: "999px",
                fontWeight: 600,
                textTransform: "none",
                boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                transition: "all 0.2s ease",
                "&:hover": {
                  bgcolor: colors.primary[500],
                  transform: "translateY(-2px)",
                  boxShadow: "0 12px 24px rgba(0,0,0,0.12)",
                },
              }}
            >
              Light Up A Church
            </Button>

            <IconButton
              sx={{ display: { xs: "flex", md: "none" } }}
              onClick={() => setMobileMenuOpen(true)}
            >
              <MenuIcon />
            </IconButton>
          </Stack>
        </Box>
      </Box>

      {/* MOBILE DRAWER */}
      <Drawer
        anchor="right"
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: "70%",
            maxWidth: 300,
          },
        }}
      >
        <Box sx={{ p: 3 }}>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
            <IconButton onClick={() => setMobileMenuOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>

          <List>
            {navItems.map((item) => (
              <ListItem
                key={item.label}
                onClick={() => handleNavClick(item.href)}
                sx={{
                  cursor: "pointer",
                  borderRadius: 2,
                  mb: 1,
                  "&:hover": {
                    backgroundColor: "rgba(0,0,0,0.05)",
                  },
                }}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{ fontWeight: 600 }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default DonationNavabar;
